module.exports = __webpack_public_path__ + "static/media/sound-group.1c18748c.mp3";